import { ApiClientHr } from 'app/service/api-service'
import { LevelSkillEndPoint } from './constant'

export const requestGetAllLevelSkillManagement = () =>
  ApiClientHr.Get({
    url: `${LevelSkillEndPoint.LevelSkillManagement.request}/get-all`,
    params: {},
  })
